import { Editor, Element, useSlateSelector } from '../../core';
import { isSelectionContainedInNode } from '../../utils/isSelectionContainedInNode';
import { MACRO_PLACEHOLDER_PLUGIN_ID, type MacroPlaceholderPluginElement } from './types';

const getSelectedMacroPlaceholder = (editor: Editor): Nullable<MacroPlaceholderPluginElement> => {
  const selection = editor?.selection;
  if (selection == null) {
    return null;
  }

  const macroPlaceholderEntry = Editor.above(editor, {
    at: selection.anchor,
    match: (n): n is MacroPlaceholderPluginElement =>
      Element.isElement(n) && n.type === MACRO_PLACEHOLDER_PLUGIN_ID,
    mode: 'lowest',
    voids: true,
  });

  if (macroPlaceholderEntry == null) {
    return null;
  }

  if (!isSelectionContainedInNode(editor, macroPlaceholderEntry[1], selection)) {
    return null;
  }

  return macroPlaceholderEntry[0];
};

export const useSelectedMacroPlaceholder = (): Nullable<MacroPlaceholderPluginElement> =>
  useSlateSelector((editor) => getSelectedMacroPlaceholder(editor));
